import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const claimCommunity = createAsyncThunk(
  "claimCommunity",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("/community/claim/", formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchclaimCommunity = createAsyncThunk(
  "claimCommunity/fetchclaimCommuity",
  async ({ page, page_size,searchQuery }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("/community/claim/",{
        params: {
          page: page,
          page_size: page_size,
          search: searchQuery,
        }
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateClaim = createAsyncThunk(
  "community/updateClaimApi",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/community/claim/`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);
